import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from '../../../GlobalUI';

function RadioForm({
  options,
  sectionHeader,
  subHeader,
  description,
  selectedValue,
  onSelect,
}) {
  return (
    <div className="setup-config-section">
      <div className="setup-config-header">{sectionHeader} </div>
      <div className="setup-config-content">
        <b>{subHeader}</b>
        <p>{description}</p>
        {options.map(({ label, value, defaultValue }) => (
          <Radio
            label={label}
            value={value}
            checked={
              value === selectedValue || (!selectedValue && defaultValue)
            }
            onClick={onSelect}
            key={label + selectedValue}
          />
        ))}
      </div>
    </div>
  );
}

RadioForm.propTypes = {
  options: PropTypes.array,
  sectionHeader: PropTypes.string,
  subHeader: PropTypes.string,
  description: PropTypes.string,
  selectedValue: PropTypes.any,
  onSelect: PropTypes.func,
};

export default RadioForm;
